<template>
  <div>
    <v-card class="ma-2">
      <v-card-title>
        MLB Fantasy Player Props
        <v-spacer></v-spacer>

        <v-col cols="12" md="4" sm="5">
          <v-row justify="center" align="center">
            <small>Confidence :</small> <br />&nbsp;
            <v-col class="light-green caption text-center"
              ><span>Low </span></v-col
            >
            <v-col class="medium-green caption text-center"
              ><span>Medium </span></v-col
            >
            <v-col class="dark-green caption text-center"
              ><span>High </span></v-col
            >
          </v-row>
        </v-col>
        <v-spacer></v-spacer>

        <v-col cols="12" md="5" sm="3">
          <v-row align="center" justify="end">
            <v-col md="7" cols="7" sm="6">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search Player"
                single-line
                dense
                outlined
                hide-details
              ></v-text-field>
            </v-col>

            <v-col cols="5" md="4" sm="3">
              <v-card-actions>
                <v-switch v-model="switch1" inset label="Props"></v-switch>
                <!-- <v-switch
                class="px-2"
                v-model="switch2"
                :disabled="switch1 ? false : true"
                inset
                label="Confidence"
                @change="enableConfidence"
              ></v-switch> -->
              </v-card-actions>
            </v-col>
          </v-row>
        </v-col>
      </v-card-title>

      <!-- //? hitters -->
      <v-card-subtitle class="overline font-weight-bold">
        Hitter
      </v-card-subtitle>
      <v-data-table
        :headers="computedHitterHeader"
        :items="computedHittersOnly"
        :items-per-page="10"
        class="elevation-1 projection-table"
        mobile-breakpoint="0"
        calculate-widths
        sort-by="Name"
        :search="search"
      >
        <!-- header -->
        <template
          v-for="(h, index) in computedHitterHeader"
          v-slot:[`header.${h.value}`]="{ computedHitterHeader }"
        >
          <span class="team-w-mg" :key="h.text" v-if="h.img">
            <span>{{ h.text }}</span>
            <v-avatar size="20"> <img :src="h.img" /></v-avatar>
          </span>

            <span class="team-w-mg" v-else :key="index">{{ h.text }}</span>
          </template>
          <!-- header -->

          <!-- date -->
          <template v-slot:item.DateTime="{ item }">
            <p>{{ item.DateTime | DatetimeFormat }}</p>
          </template>

          <!--//* matchup -->
          <template v-slot:item.Game="{ item }">
            <p class="body-2" v-if="item.HomeOrAway == 'HOME'">
              {{ item.Opponent }}&nbsp;
              <small class="black--text">@</small>
              <span>
              {{ item.Team }}
            </span>
            </p>

            <p class="body-2" v-if="item.HomeOrAway == 'AWAY'">
              {{ item.Team }}&nbsp;
              <small class="black--text">@</small>
              <span>
              {{ item.Opponent }}
            </span>
            </p>
          </template>
          <!--//* matchup ends -->

          <template v-slot:item.ProfilePic="{ item }">
            <!-- //* avatar -->
            <v-avatar width="35" height="40">
              <img :src="item.ProfilePic" />
            </v-avatar>
            <!-- //* avatar ends-->
          </template>

          <!-- CalFantasyPoints -->
          <template v-slot:item.CalFantasyPoints="{ item }">
            <p v-if="item.CalFantasyPoints == ''">_</p>
            <p v-else>{{ parseFloat(item.CalFantasyPoints).toFixed(2) }}%</p>
          </template>

          <template v-slot:item.confidenceFantasyPoints="{ item }">
            <p
                class="light-green"
                v-if="
              parseFloat(item.CalFantasyPoints) >= 0 &&
              parseFloat(item.CalFantasyPoints) < 15
            "
            >
              Over
            </p>
            <p
                class="medium-green"
                v-else-if="
              parseFloat(item.CalFantasyPoints) >= 15 &&
              parseFloat(item.CalFantasyPoints) <= 33
            "
            >
              Over
            </p>

            <p
                class="dark-green"
                v-else-if="parseFloat(item.CalFantasyPoints) >= 33"
            >
              Over
            </p>

            <p
                class="light-green"
                v-else-if="
              parseFloat(item.CalFantasyPoints) < 0 &&
              parseFloat(item.CalFantasyPoints) >= -15
            "
            >
              Under
            </p>

            <p
                class="medium-green"
                v-else-if="
              parseFloat(item.CalFantasyPoints) <= -15 &&
              parseFloat(item.CalFantasyPoints) >= -33
            "
            >
              Under
            </p>

            <p
                class="dark-green"
                v-else-if="parseFloat(item.CalFantasyPoints) < -33"
            >
              Under
            </p>
          </template>

          <!-- CalStrikeouts -->
          <template v-slot:item.CalStrikeouts="{ item }">
            <p v-if="!item.CalStrikeouts">_</p>
            <p v-else>{{ parseFloat(item.CalStrikeouts).toFixed(2) }}%</p>
          </template>

          <template v-slot:item.confidenceStrikeout="{ item }">
            <p
                class="light-green"
                v-if="
              parseFloat(item.CalStrikeouts) >= 0 &&
              parseFloat(item.CalStrikeouts) < 15
            "
            >
              Over
            </p>
            <p
                class="medium-green"
                v-else-if="
              parseFloat(item.CalStrikeouts) >= 15 &&
              parseFloat(item.CalStrikeouts) <= 33
            "
            >
              Over
            </p>

            <p
                class="dark-green"
                v-else-if="parseFloat(item.CalStrikeouts) >= 33"
            >
              Over
            </p>

            <p
                class="light-green"
                v-else-if="
              parseFloat(item.CalStrikeouts) < 0 &&
              parseFloat(item.CalStrikeouts) >= -15
            "
            >
              Under
            </p>

            <p
                class="medium-green"
                v-else-if="
              parseFloat(item.CalStrikeouts) <= -15 &&
              parseFloat(item.CalStrikeouts) >= -33
            "
            >
              Under
            </p>

            <p
                class="dark-green"
                v-else-if="parseFloat(item.CalStrikeouts) < -33"
            >
              Under
            </p>
          </template>

          <!-- CalHits -->
          <template v-slot:item.CalHits="{ item }">
            <p v-if="!item.CalHits">_</p>
            <p v-else>{{ parseFloat(item.CalHits).toFixed(2) }}%</p>
          </template>

          <template v-slot:item.confidenceHit="{ item }">
            <p
                class="light-green"
                v-if="
              parseFloat(item.CalHits) >= 0 && parseFloat(item.CalHits) < 15
            "
            >
              Over
            </p>
            <p
                class="medium-green"
                v-else-if="
              parseFloat(item.CalHits) >= 15 && parseFloat(item.CalHits) <= 33
            "
            >
              Over
            </p>

            <p class="dark-green" v-else-if="parseFloat(item.CalHits) >= 33">
              Over
            </p>

            <p
                class="light-green"
                v-else-if="
              parseFloat(item.CalHits) < 0 && parseFloat(item.CalHits) >= -15
            "
            >
              Under
            </p>

            <p
                class="medium-green"
                v-else-if="
              parseFloat(item.CalHits) <= -15 && parseFloat(item.CalHits) >= -33
            "
            >
              Under
            </p>

            <p class="dark-green" v-else-if="parseFloat(item.CalHits) < -33">
              Under
            </p>
          </template>

          <!-- CalRuns -->
          <template v-slot:item.CalRuns="{ item }">
            <p v-if="!item.CalRuns">_</p>
            <p v-else>{{ parseFloat(item.CalRuns).toFixed(2) }}%</p>
          </template>

          <template v-slot:item.confidenceRun="{ item }">
            <p
                class="light-green"
                v-if="
              parseFloat(item.CalRuns) >= 0 && parseFloat(item.CalRuns) < 15
            "
            >
              Over
            </p>
            <p
                class="medium-green"
                v-else-if="
              parseFloat(item.CalRuns) >= 15 && parseFloat(item.CalRuns) <= 33
            "
            >
              Over
            </p>

            <p class="dark-green" v-else-if="parseFloat(item.CalRuns) >= 33">
              Over
            </p>

            <p
                class="light-green"
                v-else-if="
              parseFloat(item.CalRuns) < 0 && parseFloat(item.CalRuns) >= -15
            "
            >
              Under
            </p>

            <p
                class="medium-green"
                v-else-if="
              parseFloat(item.CalRuns) <= -15 && parseFloat(item.CalRuns) >= -33
            "
            >
              Under
            </p>

            <p class="dark-green" v-else-if="parseFloat(item.CalRuns) < -33">
              Under
            </p>
          </template>

          <!--total base  -->
          <template v-slot:item.CalTotalBases="{ item }">
            <p v-if="!item.CalTotalBases">_</p>
            <p v-else>{{ parseFloat(item.CalTotalBases).toFixed(2) }}%</p>
          </template>

          <template v-slot:item.confidenceTotalbase="{ item }">
            <p
                class="light-green"
                v-if="
              parseFloat(item.CalTotalBases) >= 0 &&
              parseFloat(item.CalTotalBases) < 15
            "
            >
              Over
            </p>
            <p
                class="medium-green"
                v-else-if="
              parseFloat(item.CalTotalBases) >= 15 &&
              parseFloat(item.CalTotalBases) <= 33
            "
            >
              Over
            </p>

            <p
                class="dark-green"
                v-else-if="parseFloat(item.CalTotalBases) >= 33"
            >
              Over
            </p>

            <p
                class="light-green"
                v-else-if="
              parseFloat(item.CalTotalBases) < 0 &&
              parseFloat(item.CalTotalBases) >= -15
            "
            >
              Under
            </p>

            <p
                class="medium-green"
                v-else-if="
              parseFloat(item.CalTotalBases) <= -15 &&
              parseFloat(item.CalTotalBases) >= -33
            "
            >
              Under
            </p>

            <p
                class="dark-green"
                v-else-if="parseFloat(item.CalTotalBases) < -33"
            >
              Under
            </p>
          </template>

          <!-- Runs battted-->
          <template v-slot:item.CalRunsBattedIn="{ item }">
            <p v-if="!item.CalRunsBattedIn">_</p>
            <p v-else>{{ parseFloat(item.CalRunsBattedIn).toFixed(2) }}%</p>
          </template>

          <template v-slot:item.confidenceRunBatted="{ item }">
            <p
                class="light-green"
                v-if="
              parseFloat(item.CalRunsBattedIn) >= 0 &&
              parseFloat(item.CalRunsBattedIn) < 15
            "
            >
              Over
            </p>
            <p
                class="medium-green"
                v-else-if="
              parseFloat(item.CalRunsBattedIn) >= 15 &&
              parseFloat(item.CalRunsBattedIn) <= 33
            "
            >
              Over
            </p>

            <p
                class="dark-green"
                v-else-if="parseFloat(item.CalRunsBattedIn) >= 33"
            >
              Over
            </p>

            <p
                class="light-green"
                v-else-if="
              parseFloat(item.CalRunsBattedIn) < 0 &&
              parseFloat(item.CalRunsBattedIn) >= -15
            "
            >
              Under
            </p>

            <p
                class="medium-green"
                v-else-if="
              parseFloat(item.CalRunsBattedIn) <= -15 &&
              parseFloat(item.CalRunsBattedIn) >= -33
            "
            >
              Under
            </p>

            <p
                class="dark-green"
                v-else-if="parseFloat(item.CalRunsBattedIn) < -33"
            >
              Under
            </p>
          </template>
        </v-data-table>
        <div v-if="isFreeUser" class="paywall-wrapper">
          <div class="ghost-rows" aria-hidden="true">
            <div v-for="i in 6" :key="'ghost-hitter-' + i" class="ghost-row">
              <div class="ghost-cell ghost-avatar"></div>
              <div class="ghost-cell ghost-name"></div>
              <div class="ghost-cell ghost-short"></div>
              <div class="ghost-cell ghost-medium"></div>
              <div class="ghost-cell ghost-short"></div>
            </div>
          </div>
          <div class="paywall-cta">
            <v-icon size="40" color="white">mdi-lock-outline</v-icon>
            <p class="white--text text-h6 font-weight-bold mt-2 mb-1">Subscribe to unlock all player projections</p>
            <p class="grey--text text--lighten-1 body-2 mb-4">Free plan shows the top 5 rows only</p>
            <v-btn large color="#73c604" class="white--text" @click="goToUpgrade">Upgrade Now</v-btn>
          </div>
        </div>

      <!--//? pitchers  -->
      <v-card-subtitle class="overline font-weight-bold">
        Pitchers
      </v-card-subtitle>
      <v-data-table
        :headers="computedPitcherHeader"
        :items="computedPitchersOnly"
        :items-per-page="10"
        class="elevation-1 projection-table"
        mobile-breakpoint="0"
        calculate-widths
        sort-by="Name"
        :search="search"
      >
        <!-- header -->
        <template
          v-for="(h, index) in computedPitcherHeader"
          v-slot:[`header.${h.value}`]="{ computedPitcherHeader }"
        >
          <span class="team-w-mg" :key="h.text" v-if="h.img">
            <span>{{ h.text }}</span>
            <v-avatar size="20"> <img :src="h.img" /></v-avatar>
          </span>

          <span class="team-w-mg" v-else :key="index">{{ h.text }}</span>
        </template>
        <!-- header -->

        <!-- date -->
        <template v-slot:item.DateTime="{ item }">
          <p>{{ item.DateTime | DatetimeFormat }}</p>
        </template>

        <template v-slot:item.ProfilePic="{ item }">
          <!-- //* avatar -->
          <v-avatar width="35" height="40">
            <img :src="item.ProfilePic" />
          </v-avatar>
          <!-- //* avatar ends-->
        </template>

        <!--//* matchup -->
        <template v-slot:item.Game="{ item }">
          <p class="body-2" v-if="item.HomeOrAway == 'HOME'">
            {{ item.Opponent }}&nbsp;
            <small class="black--text">@</small>
            <span>
              {{ item.Team }}
            </span>
          </p>

          <p class="body-2" v-if="item.HomeOrAway == 'AWAY'">
            {{ item.Team }}&nbsp;
            <small class="black--text">@</small>
            <span>
              {{ item.Opponent }}
            </span>
          </p>
        </template>
        <!--//* matchup ends -->

        <!-- CalFantasyPoints -->
        <template v-slot:item.CalFantasyPoints="{ item }">
          <p v-if="!item.CalFantasyPoints">_</p>
          <p v-else>{{ parseFloat(item.CalFantasyPoints).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceFantasyPoints="{ item }">
          <p
            class="light-green"
            v-if="
              parseFloat(item.CalFantasyPoints) >= 0 &&
              parseFloat(item.CalFantasyPoints) < 15
            "
          >
            Over
          </p>
          <p
            class="medium-green"
            v-else-if="
              parseFloat(item.CalFantasyPoints) >= 15 &&
              parseFloat(item.CalFantasyPoints) <= 33
            "
          >
            Over
          </p>

          <p
            class="dark-green"
            v-else-if="parseFloat(item.CalFantasyPoints) >= 33"
          >
            Over
          </p>

          <p
            class="light-green"
            v-else-if="
              parseFloat(item.CalFantasyPoints) < 0 &&
              parseFloat(item.CalFantasyPoints) >= -15
            "
          >
            Under
          </p>

          <p
            class="medium-green"
            v-else-if="
              parseFloat(item.CalFantasyPoints) <= -15 &&
              parseFloat(item.CalFantasyPoints) >= -33
            "
          >
            Under
          </p>

          <p
            class="dark-green"
            v-else-if="parseFloat(item.CalFantasyPoints) < -33"
          >
            Under
          </p>
        </template>

        <!-- CalHits -->
        <template v-slot:item.CalHits="{ item }">
          <p v-if="!item.CalHits">_</p>
          <p v-else>{{ parseFloat(item.CalHits).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceHits="{ item }">
          <p
            class="light-green"
            v-if="
              parseFloat(item.CalHits) >= 0 && parseFloat(item.CalHits) < 15
            "
          >
            Over
          </p>
          <p
            class="medium-green"
            v-else-if="
              parseFloat(item.CalHits) >= 15 && parseFloat(item.CalHits) <= 33
            "
          >
            Over
          </p>

          <p class="dark-green" v-else-if="parseFloat(item.CalHits) >= 33">
            Over
          </p>

          <p
            class="light-green"
            v-else-if="
              parseFloat(item.CalHits) < 0 && parseFloat(item.CalHits) >= -15
            "
          >
            Under
          </p>

          <p
            class="medium-green"
            v-else-if="
              parseFloat(item.CalHits) <= -15 && parseFloat(item.CalHits) >= -33
            "
          >
            Under
          </p>

          <p class="dark-green" v-else-if="parseFloat(item.CalHits) < -33">
            Under
          </p>
        </template>

        <!-- CalRuns -->
        <template v-slot:item.CalRuns="{ item }">
          <p v-if="!item.CalRuns">_</p>
          <p v-else>{{ parseFloat(item.CalRuns).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceRuns="{ item }">
          <p
            class="light-green"
            v-if="
              parseFloat(item.CalRuns) >= 0 && parseFloat(item.CalRuns) < 15
            "
          >
            Over
          </p>
          <p
            class="medium-green"
            v-else-if="
              parseFloat(item.CalRuns) >= 15 && parseFloat(item.CalRuns) <= 33
            "
          >
            Over
          </p>

          <p class="dark-green" v-else-if="parseFloat(item.CalRuns) >= 33">
            Over
          </p>

          <p
            class="light-green"
            v-else-if="
              parseFloat(item.CalRuns) < 0 && parseFloat(item.CalRuns) >= -15
            "
          >
            Under
          </p>

          <p
            class="medium-green"
            v-else-if="
              parseFloat(item.CalRuns) <= -15 && parseFloat(item.CalRuns) >= -33
            "
          >
            Under
          </p>

          <p class="dark-green" v-else-if="parseFloat(item.CalRuns) < -33">
            Under
          </p>
        </template>

        <!-- CalStrikeouts -->
        <template v-slot:item.CalStrikeouts="{ item }">
          <p v-if="!item.CalStrikeouts">_</p>
          <p v-else>{{ parseFloat(item.CalStrikeouts).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceStrikeouts="{ item }">
          <p
            class="light-green"
            v-if="
              parseFloat(item.CalStrikeouts) >= 0 &&
              parseFloat(item.CalStrikeouts) < 15
            "
          >
            Over
          </p>
          <p
            class="medium-green"
            v-else-if="
              parseFloat(item.CalStrikeouts) >= 15 &&
              parseFloat(item.CalStrikeouts) <= 33
            "
          >
            Over
          </p>

          <p
            class="dark-green"
            v-else-if="parseFloat(item.CalStrikeouts) >= 33"
          >
            Over
          </p>

          <p
            class="light-green"
            v-else-if="
              parseFloat(item.CalStrikeouts) < 0 &&
              parseFloat(item.CalStrikeouts) >= -15
            "
          >
            Under
          </p>

          <p
            class="medium-green"
            v-else-if="
              parseFloat(item.CalStrikeouts) <= -15 &&
              parseFloat(item.CalStrikeouts) >= -33
            "
          >
            Under
          </p>

          <p
            class="dark-green"
            v-else-if="parseFloat(item.CalStrikeouts) < -33"
          >
            Under
          </p>
        </template>
      </v-data-table>
      <div v-if="isFreeUser" class="paywall-wrapper">
        <div class="ghost-rows" aria-hidden="true">
          <div v-for="i in 6" :key="'ghost-pitcher-' + i" class="ghost-row">
            <div class="ghost-cell ghost-avatar"></div>
            <div class="ghost-cell ghost-name"></div>
            <div class="ghost-cell ghost-short"></div>
            <div class="ghost-cell ghost-medium"></div>
            <div class="ghost-cell ghost-short"></div>
          </div>
        </div>
        <div class="paywall-cta">
          <v-icon size="40" color="white">mdi-lock-outline</v-icon>
          <p class="white--text text-h6 font-weight-bold mt-2 mb-1">Subscribe to unlock all player projections</p>
          <p class="grey--text text--lighten-1 body-2 mb-4">Free plan shows the top 5 rows only</p>
          <v-btn large color="#73c604" class="white--text" @click="goToUpgrade">Upgrade Now</v-btn>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "MlbProjection",
  data() {
    return {
      switch1: true,
      search: "",
      operator: localStorage.getItem("gameOperator"),
      // switch2: false,
      hittersHeader: [
        {
          text: "",
          value: "ProfilePic",
          sortable: false,
          width: "70",
        },
        {
          text: "Player Name",
          value: "Name",
          width: "150",
        },
        {
          text: "Team",
          value: "Team",
          width: "100",
        },
        {
          text: "Opp",
          value: "Game",
          width: "120",
        },

        {
          text: "Date",
          value: "DateTime",
          width: "150",
        },

        {
          text: "Projection",
          value:
            this.operator === "DraftKings"
              ? "DraftKingsProjection"
              : "FandDualProjection",
          width: "120",
        },

        // *
        // {
        //   text: 'Fantasy Points',
        //   value: 'FantasyFantasyPoints',
        //   width: '110',
        //   img: '/favicon.ico',
        // },
        //
        // {
        //   text: 'O/U',
        //   value: 'MonkeyFantasyPoints',
        //   // img: '/img/monkeyKnife.jpeg',
        // },
        //
        // {
        //   text: '% Diff',
        //   value: 'CalFantasyPoints',
        // },
        //
        // {
        //   text: 'Confidence',
        //   value: 'confidenceFantasyPoints',
        //   sortable: false,
        //   width: '130',
        // },

        // *
        // {
        //   text: "Strikeouts",
        //   value: "FantasyStrikeouts",
        //   img: "/favicon.ico",
        //   width: "110",
        //   class: "black--text",
        // },

        // {
        //   text: "O/U",
        //   value: "MonkeyStrikeouts",
        //   // img: '/img/monkeyKnife.jpeg',
        //   width: "110",
        //   class: "black--text",
        // },

        // {
        //   text: "% Diff",
        //   value: "CalStrikeouts",
        //   width: "110",
        //   class: "black--text",
        // },

        // {
        //   text: "Confidence",
        //   value: "confidenceStrikeout",
        //   sortable: false,
        //   width: "130",
        //   class: "black--text",
        // },

        // *
        {
          text: "Hit",
          value: "FantasyHits",
          width: "110",
          img: "/favicon.ico",
        },

        {
          text: "O/U",
          value: "MonkeyHits",
          width: "110",
          // img: '/img/monkeyKnife.jpeg',
        },

        {
          text: "% Diff",
          value: "CalHits",
          width: "110",
        },

        {
          text: "Confidence",
          sortable: false,
          value: "confidenceHit",
          width: "130",
        },

        // *
        {
          text: "Runs batted in",
          value: "FantasyRunsBattedIn",
          width: "100",
          img: "/favicon.ico",
          class: "black--text",
        },

        {
          text: "O/U",
          value: "MonkeyRunsBattedIn",
          width: "100",
          // img: '/img/monkeyKnife.jpeg',
          class: "black--text",
        },

        {
          text: "% Diff",
          value: "CalRunsBattedIn",
          width: "110",
          class: "black--text",
        },

        {
          text: "Confidence",
          value: "confidenceRunBatted",
          width: "130",
          class: "black--text",
        },

        // *
        {
          text: "Total bases",
          value: "FantasyTotalBases",
          width: "100",
          img: "/favicon.ico",
        },

        {
          text: "O/U",
          value: "MonkeyTotalBases",
          width: "100",
          // img: '/img/monkeyKnife.jpeg',
        },

        {
          text: "% Diff",
          value: "CalTotalBases",
          width: "110",
        },

        {
          text: "Confidence",
          value: "confidenceTotalbase",
          width: "130",
        },

        //*
        {
          text: "Runs",
          value: "FantasyRuns",
          width: "100",
          img: "/favicon.ico",
          class: "black--text",
        },

        {
          text: "O/U",
          value: "MonkeyRuns",
          width: "100",
          // img: '/img/monkeyKnife.jpeg',
          class: "black--text",
        },

        {
          text: "% Diff",
          value: "CalRuns",
          width: "110",
          class: "black--text",
        },

        {
          text: "Confidence",
          value: "confidenceRun",
          width: "130",
          class: "black--text",
        },
      ],

      pitchersHeader: [
        {
          text: "",
          value: "ProfilePic",
          sortable: false,
          width: "70",
        },
        {
          text: "Player Name",
          value: "Name",
          width: "150",
        },
        {
          text: "Opp",
          value: "Game",
          width: "120",
        },

        {
          text: "Team",
          value: "Team",
          width: "100",
        },

        {
          text: "Date",
          value: "DateTime",
          width: "150",
        },

        {
          text: "Projection",
          value:
            this.operator === "DraftKings"
              ? "DraftKingsProjection"
              : "FandDualProjection",
          width: "120",
        },

        // *
        // {
        //   text: 'Fantasy Points',
        //   value: 'FantasyFantasyPoints',
        //   img: '/favicon.ico',
        //   width: '110',
        //   class: 'black--text',
        // },
        //
        // {
        //   text: 'O/U',
        //   value: 'MonkeyFantasyPoints',
        //   img: '/img/monkeyKnife.jpeg',
        //   width: '110',
        //   class: 'black--text',
        // },
        //
        // {
        //   text: '% Diff',
        //   value: 'CalFantasyPoints',
        //   width: '110',
        //   class: 'black--text',
        // },
        //
        // {
        //   text: 'Confidence',
        //   value: 'confidenceFantasyPoints',
        //   sortable: false,
        //   width: '130',
        //   class: 'black--text',
        // },

        // *
        {
          text: "Hits",
          value: "FantasyHits",
          width: "110",
          img: "/favicon.ico",
        },

        {
          text: "O/U",
          value: "MonkeyHits",
          width: "110",
          // img: '/img/monkeyKnife.jpeg',
        },

        {
          text: "% Diff",
          value: "CalHits",
          width: "110",
        },

        {
          text: "Confidence",
          sortable: false,
          value: "confidenceHits",
          width: "130",
        },

        // *
        {
          text: "Runs",
          value: "FantasyRuns",
          width: "100",
          img: "/favicon.ico",
          class: "black--text",
        },

        {
          text: "O/U",
          value: "MonkeyRuns",
          width: "100",
          // img: '/img/monkeyKnife.jpeg',
          class: "black--text",
        },

        {
          text: "% Diff",
          value: "CalRuns",
          width: "110",
          class: "black--text",
        },

        {
          text: "Confidence",
          value: "confidenceRuns",
          width: "130",
          class: "black--text",
        },

        // *
        {
          text: "Strikeouts",
          value: "FantasyStrikeouts",
          width: "100",
          img: "/favicon.ico",
          class: "black--text",
        },

        {
          text: "O/U",
          value: "MonkeyStrikeouts",
          width: "100",
          // img: '/img/monkeyKnife.jpeg',
          class: "black--text",
        },

        {
          text: "% Diff",
          value: "CalStrikeouts",
          width: "110",
          class: "black--text",
        },

        {
          text: "Confidence",
          value: "confidenceStrikeouts",
          width: "130",
          class: "black--text",
        },
      ],
    };
  },

  computed: {
    ...mapState("MlbModule", ["mlb_props"]),
    ...mapState("userModule", ["userState"]),

    isFreeUser() {
      const planType = localStorage.getItem('planType');
      return planType === 'Free' || (this.userState && this.userState.plantype === 'Free');
    },

    computedHitterHeader() {
      if (this.switch1) {
        return this.hittersHeader;
      } else if (!this.switch1) {
        let newHeader = this.hittersHeader.filter((column) => {
          return (
            !column.value.includes("MonkeyFantasyPoints") &&
            !column.value.includes("CalFantasyPoints") &&
            !column.value.includes("confidenceFantasyPoints") &&
            !column.value.includes("MonkeyStrikeouts") &&
            !column.value.includes("CalStrikeouts") &&
            !column.value.includes("confidenceStrikeout") &&
            !column.value.includes("MonkeyHits") &&
            !column.value.includes("CalHits") &&
            !column.value.includes("confidenceHit") &&
            !column.value.includes("MonkeyRunsBattedIn") &&
            !column.value.includes("CalRunsBattedIn") &&
            !column.value.includes("confidenceRunBatted") &&
            !column.value.includes("MonkeyRuns") &&
            !column.value.includes("CalRuns") &&
            !column.value.includes("confidenceRun") &&
            !column.value.includes("MonkeyTotalBases") &&
            !column.value.includes("CalTotalBases") &&
            !column.value.includes("confidenceTotalbase")
          );
        });
        return newHeader;
      }
    },

    computedPitcherHeader() {
      if (this.switch1) {
        return this.pitchersHeader;
      } else if (!this.switch1) {
        let newHeader = this.pitchersHeader.filter((column) => {
          return (
            !column.value.includes("MonkeyFantasyPoints") &&
            !column.value.includes("CalFantasyPoints") &&
            !column.value.includes("confidenceFantasyPoints") &&
            !column.value.includes("MonkeyHits") &&
            !column.value.includes("CalHits") &&
            !column.value.includes("confidenceHits") &&
            !column.value.includes("MonkeyRuns") &&
            !column.value.includes("CalRuns") &&
            !column.value.includes("confidenceRuns") &&
            !column.value.includes("MonkeyStrikeouts") &&
            !column.value.includes("CalStrikeouts") &&
            !column.value.includes("confidenceStrikeouts")
          );
        });
        return newHeader;
      }
    },

    computedHittersOnly() {
      if (this.mlb_props.teams) {
        let nonPitcher = this.mlb_props.teams.filter((_player) => {
          return !_player.Position.includes("P");
        });
        return this.isFreeUser ? nonPitcher.slice(0, 5) : nonPitcher;
      } else return [];
    },

    computedPitchersOnly() {
      if (this.mlb_props.teams) {
        let Pitchers = this.mlb_props.teams.filter((_player) => {
          return _player.Position.includes("P");
        });
        return this.isFreeUser ? Pitchers.slice(0, 5) : Pitchers;
      } else return [];
    },
  },

  created() {
    this.fetchNhlPropsData();
  },

  methods: {
    fetchNhlPropsData() {
      this.$store.dispatch("MlbModule/getMlbProps");
    },

    goBack() {
      this.$router.go(-1);
    },

    goToUpgrade() {
      this.$router.push({ name: "upgradePlan" });
    },
  },
};
</script>

<style scoped>
.theme--light.v-data-table
  >>> .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

span.team-w-mg {
  /* display: flex !important; */
  float: left;
}

.theme--light.v-data-table
  >>> .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th.black--text {
  background-color: #cfd8dc !important;
}

.projection-table >>> .v-data-table-header__icon {
  opacity: 1;
}

.light-green {
  background-clip: #99cc99;
  padding: 5px;
  border-radius: 3px;
  color: white;
  text-align: center;
  font-weight: 800;
}

.medium-green {
  background-color: #33cc66;
  padding: 5px;
  border-radius: 3px;
  color: white;
  text-align: center;
  font-weight: 800;
}

.dark-green {
  background-color: #336633;
  padding: 5px;
  border-radius: 3px;
  color: white;
  text-align: center;
  font-weight: 800;
}

.paywall-wrapper {
  position: relative;
  overflow: hidden;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}
.ghost-rows { filter: blur(5px); pointer-events: none; user-select: none; }
.ghost-row { display: flex; align-items: center; padding: 12px 16px; border-bottom: 1px solid rgba(0,0,0,0.08); gap: 20px; }
.ghost-cell { background: #e0e0e0; border-radius: 4px; height: 14px; flex-shrink: 0; }
.ghost-avatar { width: 36px; height: 36px; border-radius: 50%; }
.ghost-name   { width: 110px; }
.ghost-short  { width: 50px; }
.ghost-medium { width: 80px; }
.paywall-cta {
  position: absolute; inset: 0;
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  background: rgba(0, 0, 0, 0.72);
  padding: 24px; text-align: center;
}
</style>
